export const PRED_STATUS = {
  none: ["Non répondu", "border-white/10 text-slate-400"],
  saved: ["Enregistré", "border-[#B7F52A]/30 text-[#B7F52A]"],
  locked: ["Verrouillé", "border-sky-300/30 text-sky-200"],
  waiting: ["En attente de résultat", "border-amber-300/30 text-amber-200"],
  resolved: ["Résolu", "border-[#B7F52A]/40 bg-[#B7F52A]/10 text-[#B7F52A]"],
  void: ["Neutralisé", "border-white/10 text-slate-400"],
};

export function winnerStatus(g) {
  if (!g.my_pick) return "none";
  if (g.status === "cancelled") return "void";
  if (g.status === "final") return g.points != null || g.breakdown ? "resolved" : "waiting";
  if (g.locked || g.status === "live") return "locked";
  return "saved";
}

export function bonusStatus(q, g) {
  if (q.status === "void") return "void";
  if (!q.my_answer) return "none";
  if (q.status === "resolved") return "resolved";
  if (g.status === "final") return "waiting";
  if (g.locked || q.status !== "open") return "locked";
  return "saved";
}

export const StatusPill = ({ s, testId }) => (
  <span data-testid={testId} data-status={s} className={`inline-flex shrink-0 items-center rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${PRED_STATUS[s][1]}`}>
    {PRED_STATUS[s][0]}
  </span>
);
